import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlignLeftLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.25 2.33984C3.66421 2.33984 4 2.67563 4 3.08984V20.9087C4 21.3229 3.66421 21.6587 3.25 21.6587C2.83579 21.6587 2.5 21.3229 2.5 20.9087V3.08984C2.5 2.67563 2.83579 2.33984 3.25 2.33984Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.20478 4.12695C8.33868 4.12695 7.63672 4.82891 7.63672 5.69501V7.76102C7.63672 8.62711 8.33868 9.32907 9.20478 9.32907H14.1436C15.0097 9.32907 15.7116 8.62711 15.7116 7.76102V5.69501C15.7116 4.82891 15.0097 4.12695 14.1436 4.12695H9.20478ZM6.13672 5.69501C6.13672 4.00049 7.51025 2.62695 9.20478 2.62695H14.1436C15.8381 2.62695 17.2116 4.00049 17.2116 5.69501V7.76102C17.2116 9.45554 15.8381 10.8291 14.1436 10.8291H9.20478C7.51025 10.8291 6.13672 9.45554 6.13672 7.76102V5.69501Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.20478 14.6699C8.33868 14.6699 7.63672 15.3719 7.63672 16.238V18.304C7.63672 19.1701 8.33868 19.872 9.20478 19.872H18.9316C19.7977 19.872 20.4996 19.1701 20.4996 18.304V16.238C20.4996 15.3719 19.7977 14.6699 18.9316 14.6699H9.20478ZM6.13672 16.238C6.13672 14.5435 7.51025 13.1699 9.20478 13.1699H18.9316C20.6261 13.1699 21.9996 14.5435 21.9996 16.238V18.304C21.9996 19.9985 20.6261 21.372 18.9316 21.372H9.20478C7.51025 21.372 6.13672 19.9985 6.13672 18.304V16.238Z",
			fill: "currentColor"
		})
	]
});
export default SvgAlignLeftLine;
